import {
  getAsync,
  putAsync,
  uploadAsync,
  downloadAsync,
  deleteAsync,
} from "../helpers/apiHelper";

const endpoint = process.env.VUE_APP_BACKEND + "/api/media";

// GET all medias for current user
export async function getAllMediasForCurrentUserAsync() {
  return await getAsync(`${endpoint}/GetAllForCurrentUser`)
}

// GET DOWNLOAD a media by its path
export async function getDownloadMediaByPathAsync(path) {
  return await downloadAsync(`${endpoint}/GetDownloadMediaByPath`, path);
}

// GET all mediaTypes for current user
export async function GetAllMediaTypesForCurrentUserAsync() {
  return await getAsync(`${endpoint}/GetAllMediaTypesForCurrentUser`);
}

// CREATE a new media
export async function createMediaAsync(model) {
  return await uploadAsync(`${endpoint}`, model);
}

// UPDATE a media
export async function updateMediaAsync(model) {
  return await putAsync(`${endpoint}/${model.id}`, model);
}

export async function deleteMediaAsync(id) {
  return await deleteAsync(`${endpoint}?id=${id}`);
}